import { HttpClient, HttpHeaders } from '@angular/common/http';


import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { IntegrationType } from '../../project-request/models/file.model';

@Injectable({
  providedIn: 'root'
})
export class FilesServiceService {

  handleError: any;
  headers = new HttpHeaders({ 'Content-Type': 'application/json' });

  constructor(protected http: HttpClient) { }

  uploadProjectFile(file: File, requestVersionId: any) {
    const formData = new FormData();
    formData.append('file', file);
    formData.append('projectId', requestVersionId.toString());

    return this.http.post<any>(`${environment.API_URL}/api/files/uploadProjectFile`, formData)
  }

  uploadAbsenceFile(file: File, absenceId: any) {
    const formData = new FormData();
    formData.append('file', file);
    formData.append('absenceId', absenceId.toString());

    return this.http.post<any>(`${environment.API_URL}/api/files/uploadAbsenceFile`, formData)
  }

  uploadVacationFile(file: File, absenceId: any) {
    const formData = new FormData();
    formData.append('file', file);
    formData.append('vacationId', absenceId.toString());

    return this.http.post<any>(`${environment.API_URL}/api/files/uploadVacationFile`, formData)
  }

  uploadSupportFile(file: File, supportId: any) {
    const formData = new FormData();
    formData.append('file', file);
    formData.append('supportId', supportId.toString());

    return this.http.post<any>(`${environment.API_URL}/api/files/uploadSupportFile`, formData)
  }
  uploadBugFile(file: File, bugId: any) {
    const formData = new FormData();
    formData.append('file', file);
    formData.append('bugId', bugId.toString());

    return this.http.post<any>(`${environment.API_URL}/api/files/uploadBugFile`, formData)
  }

  uploadTaskFile(file: File, requestVersionId: any) {
    const formData = new FormData();
    formData.append('file', file);
    formData.append('taskId', requestVersionId.toString());

    return this.http.post<any>(`${environment.API_URL}/api/files/uploadTaskFile`, formData)
  }

  uploadEventFile(file: File, requestVersionId: any) {
    const formData = new FormData();
    formData.append('file', file);
    formData.append('eventId', requestVersionId.toString());

    return this.http.post<any>(`${environment.API_URL}/api/files/uploadEventFile`, formData)
  }

  uploadWikiFile(file: File, requestVersionId: any) {
    const formData = new FormData();
    formData.append('file', file);
    formData.append('wikiId', requestVersionId.toString());

    return this.http.post<any>(`${environment.API_URL}/api/files/uploadWikiFile`, formData)
  }

  delete(id: number) {
    return this.http.delete<any>(`${environment.API_URL}/api/files/${id}`);
  }

  uploadMaterialFile(file: File, materialId: any) {
    const formData = new FormData();
    formData.append('file', file);
    formData.append('productId', materialId.toString());

    return this.http.post<any>(`${environment.API_URL}/api/files/uploadProductFile`, formData)
  }

  uploadTripFile(file: File, tripId: any) {
    const formData = new FormData();
    formData.append('file', file);
    formData.append('tripId', tripId.toString());

    return this.http.post<any>(`${environment.API_URL}/api/files/uploadTripFile`, formData)
  }

  uploadCommmentFile(file: File, commentId: any) {
    const formData = new FormData();
    formData.append('file', file);
    formData.append('commentId', commentId.toString());
    return this.http.post<any>(environment.API_URL + `/api/files/uploadCommentFile`, formData)
  }

  uploadArtifactFile(file: File, artifactId: any, integration?: IntegrationType) {
    const formData = new FormData();
    formData.append('file', file);
    formData.append('artifactId', artifactId.toString());
    if (integration) formData.append('integration', integration);
    return this.http.post<any>(environment.API_URL + `/api/files/uploadArtifactFile`, formData)
  }

  uploadMeetingFile(file: File, meetingId: any) {
    const formData = new FormData();
    formData.append('file', file);
    formData.append('meetingId', meetingId.toString());
    return this.http.post<any>(environment.API_URL + `/api/files/uploadMeetingFile`, formData)
  }
}
